import api from './api';

export interface CustomerNote {
  content: string;
  createdAt: string;
  callId?: string;
}

export interface FinishCode {
  code: string;
  createdAt: string;
  callId?: string;
  agentId?: string;
}

export interface Customer {
  _id?: string;
  firstName?: string;
  lastName?: string;
  gsm?: string;
  sabitTel?: string;
  email?: string;
  il?: string;
  ilce?: string;
  adres?: string;
  tc?: string;
  notes?: CustomerNote[];
  finishCodes?: FinishCode[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateCustomerData {
  firstName?: string;
  lastName?: string;
  gsm?: string;
  sabitTel?: string;
  email?: string;
  il?: string;
  ilce?: string;
  adres?: string;
  tc?: string;
  notes?: string;
}

class CustomerService {
  // Telefon numarasına göre müşteri getir
  async getCustomerByPhone(phoneNumber: string): Promise<Customer | null> {
    try {
      const response = await api.get(`/customers/phone/${phoneNumber}`);
      
      if (response.data.success && response.data.data) {
        return response.data.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  // Yeni müşteri oluştur
  async createCustomer(customerData: CreateCustomerData): Promise<Customer | null> {
    try {
      const response = await api.post('/customers', customerData);
      
      if (response.data.success && response.data.data) {
        console.log('✅ Customer created:', response.data.data);
        return response.data.data;
      } else {
        console.error('❌ Failed to create customer:', response.data);
        return null;
      }
    } catch (error) {
      console.error('❌ Error creating customer:', error);
      throw error; // Hatayı yukarı fırlat
    }
  }

  // Müşteri güncelle
  async updateCustomer(customerId: string, customerData: Partial<CreateCustomerData>): Promise<Customer | null> {
    try {
      console.log('📝 Updating customer:', customerId, customerData);
      const response = await api.put(`/customers/${customerId}`, customerData);
      
      if (response.data.success && response.data.data) {
        console.log('✅ Customer updated:', response.data.data);
        return response.data.data;
      } else {
        console.error('❌ Failed to update customer:', response.data);
        return null;
      }
    } catch (error) {
      console.error('❌ Error updating customer:', error);
      throw error; // Hatayı yukarı fırlat
    }
  }

  // Tüm müşterileri getir
  async getAllCustomers(): Promise<Customer[]> {
    try {
      const response = await api.get('/customers');

      if (response.data.success && response.data.data) {
        return response.data.data;
      } else {
        console.log('❌ No customers found');
        return [];
      }
    } catch (error) {
      console.error('❌ Error getting customers:', error);
      return [];
    }
  }

  // Müşteriye finish code ekle
  async addFinishCode(customerId: string, code: string, callId?: string, agentId?: string, appointmentDate?: string, notes?: string): Promise<Customer | null> {
    try {
      console.log('📝 Adding finish code to customer:', customerId, code, 'Appointment:', appointmentDate);
      const response = await api.post(`/customers/${customerId}/finish-code`, {
        code,
        callId,
        agentId,
        appointmentDate,
        notes
      });

      if (response.data.success && response.data.data) {
        console.log('✅ Finish code added:', response.data.data);
        return response.data.data;
      } else {
        console.error('❌ Failed to add finish code:', response.data);
        return null;
      }
    } catch (error) {
      console.error('❌ Error adding finish code:', error);
      throw error;
    }
  }

  // Müşteriye e-posta gönder
  async sendEmail(to: string, subject: string, body: string, emailAccountId?: string | null): Promise<{ success: boolean; message: string }> {
    try {
      console.log('📧 Sending SMTP email to:', to);
      const response = await api.post('/customers/send-email', {
        to,
        subject,
        body,
        emailAccountId
      });

      return {
        success: response.data?.success || false,
        message: response.data?.message || 'E-posta başarıyla gönderildi'
      };
    } catch (error: any) {
      console.error('❌ Error sending customer email:', error);
      return {
        success: false,
        message: error?.response?.data?.message || 'E-posta gönderilirken hata oluştu'
      };
    }
  }
}

export default new CustomerService();

